import React from 'react';
import {connect} from 'react-redux';
import {usePlanResults} from './planResultsHelper';
import SMCPage from '../../../components/core/pageComponents/SMCPage';
import {useResultsTableDimensions, useBoolean, useToggle} from '../../../utils/hooks';
import SMCTable from '../../../components/core/SMCTable/SMCTable';
import PlanWizard from '../../Wizards/PlanWizard';
import PlanFilterPane from '../../Filters/PlanFilterPane';
import {planPermissionsSelector} from '../../../store/selectors/user.selectors';
import {helpContextPageUrl} from '../../../conf/Routes';
import SMCTableActions from '../../../components/core/SMCTableActions/SMCTableActions';
import {PlanFilterSchema} from '../../../api/DBSchema/Plan';
import SMCButton from '../../../components/Simple/SMCButton';
import ButtonsContainerStyles from "../../../pages/EditorPages/ButtonsContainerStyles";


function PlanResults({
    planPermissions
}) {

    const [tableWidth, tableHeight] = useResultsTableDimensions();
    const [isNewObjectWindowOpen, openNewObjectWindow, closeNewObjectWindow] = useBoolean(false);
    const [isFilterPaneOpen, toggleFilterPane] = useToggle(false);
    
    const {
        tableContent,
        isFetching,
        fetchNextPage,
        isLastPage,
        columns,
        sortBasis,
        sortDirection,
        setSort,
        columnsState,
        setColumnsState,
        setDefaultColumnsState,
        selectedObjects,
        newObjectCallback,
        reloadButtonOnClick,
        deleteButtonOnClick,
        isPageLoaded,
        rowIdSelector,
        setSelectedObjects,
        columnsWidths,
        setColumnsWidths,
        filterObject,
        setFilterObject,
        freeTextSearch,
        toExcelAction
    } = usePlanResults();

    const canDelete = planPermissions ? planPermissions.delete : false;
    const canCreate = planPermissions ? planPermissions.create : false;
    const buttonsClasses = ButtonsContainerStyles();

    const PlanActionsMenu = ({ children }) => {
        return (
            <SMCButton 
                 labelClassName={buttonsClasses.labelColor} 
                 variant="ghost" 
                 onClick={toExcelAction}>
                     To Excel
             </SMCButton>
         );
      };

    return (
        <SMCPage loading={!isPageLoaded} helpId={helpContextPageUrl.planResults}>
            <div className="DrawResultsDiv">
                <SMCTableActions
                    openNewObjectWindow={openNewObjectWindow}
                    reloadButtonOnClick={reloadButtonOnClick}
                    deleteButtonOnClick={deleteButtonOnClick}
                    toggleFilterPane={toggleFilterPane}
                    canCreate={canCreate}
                    canDelete={canDelete}
                    isFetching={isFetching} 
                    actions={PlanActionsMenu}
                    tableContent={tableContent}
                    isFilterPaneOpen={isFilterPaneOpen}
                    selectedObjects={selectedObjects}
                    initialSearch={filterObject}
                    onSearchChange={setFilterObject}
                    searchAttribute={PlanFilterSchema.freeTextSearch}
                /> 
                <SMCTable
                    columns={columns}
                    columnsState={columnsState}
                    setColumnsState={setColumnsState}
                    setDefaultColumnsState={setDefaultColumnsState}
                    selectedObjects={selectedObjects}
                    setSelectedObjects={setSelectedObjects}
                    hasCheckAll={true}
                    defaultColumnsWidths={columnsWidths}
                    onEndResizingColumns={setColumnsWidths}
                    content={tableContent}
                    sortBasis={sortBasis}
                    sortDirection={sortDirection}
                    setSort={setSort}
                    loading={isFetching}
                    onRequestLoadPage={fetchNextPage}
                    isLastPage={isLastPage}
                    width={tableWidth}
                    height={tableHeight}
                    isFilterOpen={isFilterPaneOpen}
                    rowIdSelector={rowIdSelector}
                    filterElem={
                        <PlanFilterPane
                            initialFilter={filterObject}
                            onFilterChange={setFilterObject}
                            open={isFilterPaneOpen}
                        />
                    }
                    textToHighlight={freeTextSearch}
                    showEditIcon={false}
                />
                {/* Floating windows */}
                <PlanWizard
                    isOpen={isNewObjectWindowOpen}
                    onRequestClose={closeNewObjectWindow}
                    onSuccess={newObjectCallback}
                />
            </div>
        </SMCPage>
    );
}

const mapStateToProps = state => ({
    planPermissions: planPermissionsSelector(state)
});

const mapDispatchToProps = null;

export default connect(mapStateToProps, mapDispatchToProps)(PlanResults);